<template>
    <div class="sealPer">
        <div class="per_title">
            <div class="title">添加印模</div>
            <div class="btn" @click="$refs.seal.click();">上传图片</div>

            <input type="file" id="seal" @change="handleFileChange($event)" ref="seal" style="display: none;">

            <span>上传的图片需要清晰，图片背景为透明背景</span>
            <div class="lookBtn" @click="testDialogVisible = true">查看示例</div>
        </div>
        <div class="autograph">
            <vue-esign ref="esign" :width="889" :height="507" :isCrop="isCrop" :lineWidth="lineWidth"
                       :lineColor="lineColor"
                       :bgColor.sync="bgColor"/>
        </div>
        <div class="esignBtn">
            <div class="clearBtn" @click="handleReset">清除</div>
            <div class="saveBtn" @click="handleGenerate">采用</div>
        </div>
        <el-dialog title="示例" :visible.sync="testDialogVisible" width="30%" center id="testDialog">
            <div class="all">
                <div class="top">
                    <img src="../../../../static/img/shiLi-1.png"/>
                </div>
                <div class="bom">
                    <img src="../../../../static/img/shiLi-2.png"/>
                    <img src="../../../../static/img/shiLi-3.png"/>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import signCanvas from '../../canvas/canvas'

    export default {
        components: {
            signCanvas
        },
        data() {
            return {
                testDialogVisible: false,
                lineWidth: 6,
                lineColor: '#000000',
                bgColor: '',
                resultImg: '',
                isCrop: false
            }
        },
        methods: {
            handleFileChange(e, index) {
                let file = e.currentTarget.files[0];
                /* 限制文件上传类型 */
                let suffixName = file.name.substring(file.name.lastIndexOf('.') + 1);
                if (suffixName !== 'png') {
                    this.$message.warning("上传印模只能是 png 格式!");
                    return;
                }

                /* 限制文件上传大小 */
                let isLtSize = file.size / 1024 / 1024 < 2;
                if (!isLtSize) {
                    this.$message.warning("上传文件不能超过 2MB!");
                    return;
                }

                let size = Math.floor(file.size / 1024);
                this.getUplodPath(file);
                e.target.value = '';
            },
            async getUplodPath(file) {
                let formdata = new FormData();
                formdata.append('file', file);
                let _this = this;
                let post = () => {
                    return new Promise(resolve => {
                        _this.api.upload(formdata).then(res => {
                            console.log(res);
                            resolve(res.path);
                        })
                    });
                }
                let paht = await post();
                _this.loudSeal(paht);
            },
            handleReset() {
                this.$refs.esign.reset();
            },
            handleGenerate() {
                let _this = this;
                _this.$refs.esign.generate().then(res => {
                    _this.resultImg = res;
                    // console.log(res,'!!!!!!');
                    console.log(_this.xm.dataURLtoFile(res));
                    let file = _this.xm.dataURLtoFile(res);

                    console.log(file, '@@@@@@@@@@@@@@@@@@');


                    let formdata = new FormData();

                    formdata.append('file', file);

                    _this.api.upload(formdata).then(res => {
                        console.log(res);
                        _this.loudSeal(res.path);
                        _this.$refs.esign.reset();
                    })
                }).catch(err => {
                    alert(err) // 画布没有签字时会执行这里 'Not Signned'
                })
            },
            loudSeal(path) {
                let _this = this;
                let param = new FormData();
                param.append('stampTemplate', path);
                param.append('token', _this.$global.token);
                _this.api.saveStampInfo(param).then(res => {
                    console.log(res);
                    _this.$message.success('添加成功');
                    _this.$router.push({
                        name: 'sealList'
                    })
                })
            },
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    #testDialog /deep/ .el-dialog {
        background-color: #ffffff;
        border-radius: 30px;
        border: solid 1px #aaaaaa;

        .all {
            width: auto;
            height: auto;

            .top {
                @row();
            }

            .bom {
                display: @flex;
                justify-content: space-between;
                margin-top: 39px;
            }

            img {
                width: 280px;
                height: 142px;
                object-fit: cover;
            }
        }
    }

    .sealPer {
        width: @a;
        height: auto;
        margin-left: 4%;

        .per_title {
            width: @a;
            height: 40px;
            display: @flex;
            align-items: center;

            .title {
                width: auto;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
            }

            .btn {
                width: 120px;
                height: 40px;
                margin-left: 33px;
                line-height: 40px;
                text-align: center;
                letter-spacing: 1px;
                color: #ffffff;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                cursor: pointer;
            }

            span {
                width: auto;
                height: auto;
                margin-left: 17px;
                font-family: MicrosoftYaHei;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #e10000;
            }

            .lookBtn {
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #fff;
                border: solid 1px #aaaaaa;
                letter-spacing: 1px;
                color: #333333;
                margin-left: 15px;
                cursor: pointer;
            }
        }

        .autograph {
            margin-top: 30px;
            width: 1070px;
            height: 610px;
            background-color: #ffffff;
            border: solid 1px #aaaaaa;
        }

        .esignBtn {
            width: 1070px;
            height: 60px;
            display: @flex;
            justify-content: center;
            margin-top: 30px;

            .clearBtn {
                width: 200px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                letter-spacing: 1px;
                color: #333333;
                background-color: #fff;
                border: solid 1px #aaaaaa;
                cursor: pointer;
            }

            .saveBtn {
                width: 200px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                letter-spacing: 1px;
                color: #fff;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                margin-left: 70px;
                cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/seal/personalSeal.vue